import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import moment from 'moment';

import TrialMetadataDialog from '../components/trial/TrialMetadataDialog';
import {
  createTrial,
  showNotification,
  showErrorNotification,
} from '../redux/actions';
import { Trial } from '../redux/types';
import { DefaultDataType as ComboboxDataType } from '../components/layout/ComboBox';
import ApiClient from '../loopback/apiClient';
import GenericDialog from '../components/GenericDialog';

type Props = PropsFromRedux & {
  trial?: Trial,
  onClose: () => void;
  isOpen: boolean;
};

type State = {
  trials?: Trial[];
}

class AddTrialDialog extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      trials: undefined,
    };
  }

  componentDidMount() {
    this.fetchTrials();
  }

  fetchTrials = async () => {
    const trials = await ApiClient.getTrials();
    this.setState({ trials });
  };

  render() {
    const {
      trial: existingTrial,
      isOpen,
      onClose,
      showNotification: showNotificationAction,
      showErrorNotification: showErrorNotificationAction,
    } = this.props;
    const {
      trials,
    } = this.state;

    return (
      <>
        {
          trials && (
            <GenericDialog isOpen={isOpen} onRequestClose={() => onClose()}>
              <div>
                <TrialMetadataDialog
                  trial={existingTrial}
                  onSave={async (newTrial: Trial, trialTags: ComboboxDataType[]|null) => {
                    const existingCode = trials
                      .find((trial) => trial.code === newTrial.code);
                    // todo: move this check to backend
                    if (existingCode) {
                      showNotificationAction(
                        `Trial with code already exists ${existingCode.code} - Please use a different code, e.g: ${existingCode.code}-${moment.utc().format('YY')}`,
                      );
                      return;
                    }
                    const existingCostCenter = trials
                      .find((trial) => trial.costCenter === newTrial.costCenter);
                    // todo : move this check to backend
                    if (existingCostCenter) {
                      showNotificationAction(
                        `Trial with costCenter already exists ${existingCostCenter.costCenter} - Please use a different, e.g.: ${existingCostCenter.costCenter}-${moment.utc().format('YY')}`,
                      );
                      return;
                    }
                    try {
                      const res = await createTrial({ ...newTrial, version: 2 });
                      if (!trialTags) {
                        return;
                      }
                      await ApiClient.setTrialTagMapping(res.id, trialTags);
                      onClose();
                    } catch (error: any) {
                      showErrorNotificationAction(error.message);
                    }
                  }}
                  onCancel={onClose}
                />
              </div>
            </GenericDialog>
          )
        }
      </>
    );
  }
}

const dispatchProps = {
  showNotification,
  showErrorNotification,
};

const connector = connect(null, dispatchProps);
type PropsFromRedux = ConnectedProps<typeof connector>
export default connector(AddTrialDialog);
